// extracted by mini-css-extract-plugin
module.exports = {"container":"Administrator_container__2ZR3Z","card":"Administrator_card__m7gtX"};